import { nextTick, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof CarouselContentSetupService.props>

export default class CarouselContentSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _preview = ref<HTMLElement>();

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		nextTick(this.disableFocusInPreview.bind(this));
	}

	disableFocusInPreview () {
		const preview = this._preview.value as HTMLElement;
		if (!preview) return;

		const inputNodes = preview.getElementsByTagName('INPUT') as HTMLCollectionOf<HTMLInputElement>;
		const linkNodes = preview.getElementsByTagName('A') as HTMLCollectionOf<HTMLElement>;
		const btnNodes = preview.getElementsByClassName('arm-btn') as HTMLCollectionOf<HTMLElement>;
		[...inputNodes, ...linkNodes, ...btnNodes].forEach(el => el.tabIndex = -1);
	}
}
